import React, { useState, useEffect } from "react";
import { Card, Row, Col, Tag } from "antd";
import moment from "moment";

// Components
import ThreeFigure from "../../components/three-figure";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderFigureData from "../../components/render-figure-data";

// Hooks
import useDesings from "../../hooks/useDesings";

// Styles
import { ThreeBox } from "./styles";

//import multilanguage library
import { useTranslation } from 'react-i18next'

const SelectionArticle = ({ handleChangeArticle, article }) => {
  const [listOfArticles, setListOfArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);

  const { desings } = useDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    if (handleChangeArticle && selectedArticle) handleChangeArticle(selectedArticle);
  }, [selectedArticle]);

  useEffect(() => {
    const normalized = desings.map(article => {
      return {
        key: article.id,
        ...article
      };
    });

    let selected = article ? normalized.findIndex(art => art.id === article.id) : 0;

    normalized && setListOfArticles(normalized);
    if (normalized && normalized[selected]) {
      setSelectedArticle(normalized[selected]);
      setSelectedRowKey([normalized[selected].key]);
    }
  }, [desings]);

  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "articleName",
      key: "articleName",
      sorter: (a, b) => a.articleName.localeCompare(b.articleName),
      defaultSortOrder: "descend",
      ...Search("articleName")
    },
    {
      title: t('table.header.geometry'),
      dataIndex: "selected_figure",
      key: "selected_figure",
      sorter: (a, b) => a.selected_figure.localeCompare(b.selected_figure),
      //...Search("selected_figure"),
      filters: [
        { text: t('geometry.cylinder'), value: "cylinder" },
        { text: t('geometry.rhomboid'), value: "rhomboid" },
        { text: t('geometry.torus'), value: "torus" },
        { text: t('geometry.rectangle'), value: "rectangle" }
      ],
      onFilter: (value, record) => record.selected_figure.includes(value),
      render: value => t('geometry.'+value)
    },
    {
      title: t('table.header.type'),
      dataIndex: "isPrototype",
      key: "isPrototype",
      width: 100,
      render: isPrototype => (isPrototype ? t('labels.prototype') : t('labels.catalogue')),
      filters: [
        { text: t('labels.prototype'), value: true },
        { text: t('labels.catalogue'), value: false }
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.isPrototype === value
    },
    {
      title: t('table.header.article_date'),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
    }
  ];

  // rowSelection objects indicates the need for row selection
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedArticle(desings.find(obj => obj.id === record.id));
    },
    type: "radio"
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedArticle(desings.find(obj => obj.id === row.id));
  };

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table data={listOfArticles} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedArticle && selectedArticle.articleName}
          extra={selectedArticle && selectedArticle.isPrototype ? <Tag color="magenta">{t('labels.prototype')}</Tag> : <Tag color="blue">{t('labels.catalogue')}</Tag>}
          cover={
            selectedArticle && (
              <ThreeBox>
                <ThreeFigure figureData={selectedArticle && selectedArticle.figure[0]} />
              </ThreeBox>
            )
          }
        >
          <RenderFigureData selectedArticle={selectedArticle} />
        </Card>
      </Col>
    </Row>
  );
};

export default SelectionArticle;
